const SHORTHAND = /^[0-9a-f]{3}$/;
const FULL = /^[0-9a-f]{6}$/;

/** Normalizes user-typed hex to lowercase `#rrggbb`, or null when it isn't a hex color. */
export function normalizeHexColor(input: string): string | null {
  const body = input.trim().toLowerCase().replace(/^#/, '');
  if (SHORTHAND.test(body)) {
    return `#${body[0]}${body[0]}${body[1]}${body[1]}${body[2]}${body[2]}`;
  }
  return FULL.test(body) ? `#${body}` : null;
}

/** True when the input is already six digits, so committing it can't cut short a hex being typed. */
export function isFullHexColor(input: string): boolean {
  return FULL.test(input.trim().toLowerCase().replace(/^#/, ''));
}

const GREY_90_LUMINANCE = relativeLuminance('#1d1e20');

function relativeLuminance(hex: string): number {
  const [r, g, b] = [1, 3, 5].map((i) => {
    const channel = Number.parseInt(hex.slice(i, i + 2), 16) / 255;
    return channel <= 0.04045 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

/** True when a white mark contrasts more than a grey-90 one on this color; false for anything that isn't a hex color. */
export function isDarkHexColor(input: string): boolean {
  const hex = normalizeHexColor(input);
  if (!hex) return false;
  const luminance = relativeLuminance(hex);
  return 1.05 / (luminance + 0.05) > (luminance + 0.05) / (GREY_90_LUMINANCE + 0.05);
}
